import Api from './Api';
import * as urls from '../components/shared/urls';

export type Setting = {
  id: number;
  name: string;
  value: string;
  modifiedById?: number;
  modifiedDate?: Date;
  createdById: number;
  createdDate: Date;
};

export async function getAllSettings(): Promise<Setting[]> {
  const response = await Api.get<Setting[]>(`${urls.GET_SETTINGS}`);

  if (!response.ok) {
    console.error({ response });
    throw new Error('Failed to retrieve settings');
  }

  return response.data;
}

export async function getSettingByName(name: string): Promise<Setting> {
  const response = await Api.get<Setting>(`${urls.GET_SETTINGS}?name=${name}`);

  if (!response.ok) {
    console.error({ response });
    throw new Error(`Failed to retrieve setting ${name}`);
  }

  return response.data;
}

export async function getSettingById(id: number): Promise<Setting> {
  const response = await Api.get<Setting>(`${urls.GET_SETTINGS}?id=${id}`);

  if (!response.ok) {
    console.error({ response });
    throw new Error(`Failed to retrieve setting with id ${id}`);
  }

  return response.data;
}

export async function saveSetting(setting: Setting): Promise<Setting> {
  const response = await Api.post<Setting>(`${urls.SAVE_SETTING}`, setting);

  if (!response.ok) {
    console.error({ response });
    throw new Error('Failed to save setting');
  }

  return response.data;
}

export const settings = {
  DriverReportHeldDays: 'DriverReportHeldDays',
  LogWorkflowErrors: 'LogWorkflowErrors',
  LogWorkflowChanges: 'LogWorkflowChanges'

};
